import { createUseStyles } from 'react-jss'

import { phonesDown, tabletDown } from '../../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  totalInfo: {
    display: 'flex',
    gap: 40
  },
  infoBlock: {
    flex: 1,
    padding: '18px'
  },
  infoBlockContent: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 80
  },
  totalNumber: {
    fontWeight: '700',
    fontSize: 48
  },
  totalSocialValue: {
    color: '#2A62C6'
  },
  totalNumberDescription: {
    fontSize: 17,
    fontWeight: 400,
    color: '#555555'
  },

  [`@media screen and (${tabletDown})`]: {
    totalInfo: {
      flexDirection: 'column'
    }
  },

  [`@media screen and (${phonesDown})`]: {
    totalBeneficiaries: {
      minWidth: 'unset'
    },
    infoBlockContent: {
      gap: 10
    }
  }
})

export default useStyles
